import { Link } from "react-router-dom";
import { Instagram, Mail, Phone } from "lucide-react";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Footer() {
  const [settings, setSettings] = useState({});
  useEffect(() => { api.get("/site-settings").then((r) => setSettings(r.data)).catch(() => {}); }, []);

  return (
    <footer data-testid="site-footer" className="relative bg-[#1A1918] text-[#EAE6DF] mt-32">
      <div className="container-editorial py-20 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img src="/brand/hiraya-logo-5.png" alt="Hiraya" className="h-16 md:h-20 w-auto -ml-2" />
            <div className="text-[10px] uppercase tracking-[0.32em] text-[#8A837A] mt-3">Formerly Adorn Designs · Since 2017</div>
            <p className="mt-6 text-[#C9C3BA] max-w-md text-sm leading-relaxed">
              {settings.description || "Hiraya (formerly Adorn Designs) crafts purposeful, tailor-made interiors from Surat — utility first, warmth always."}
            </p>
            {settings.address && (
              <p className="mt-4 text-xs text-[#8A837A] max-w-md leading-relaxed">{settings.address}</p>
            )}
            <Link
              to="/consultation"
              data-testid="footer-cta-book"
              className="inline-flex mt-8 px-6 py-3 border border-[#EAE6DF] text-[#F9F8F6] text-xs uppercase tracking-[0.24em] hover:bg-[#A85C42] hover:border-[#A85C42] transition rounded-sm"
            >
              Begin a project
            </Link>
          </div>
          <div className="md:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#8A837A] mb-5">Studio</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/about" className="hover:text-[#C57457]">About</Link></li>
              <li><Link to="/services" className="hover:text-[#C57457]">Services</Link></li>
              <li><Link to="/portfolio" className="hover:text-[#C57457]">Projects</Link></li>
              <li><Link to="/process" className="hover:text-[#C57457]">Design process</Link></li>
              <li><Link to="/blog" className="hover:text-[#C57457]">Journal</Link></li>
              <li><Link to="/faqs" className="hover:text-[#C57457]">FAQs</Link></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#8A837A] mb-5">Get in touch</div>
            <ul className="space-y-3 text-sm text-[#C9C3BA]">
              {settings.email && (
                <li className="flex items-center gap-3"><Mail size={14} strokeWidth={1.5} /> <a href={`mailto:${settings.email}`} className="hover:text-[#C57457]">{settings.email}</a></li>
              )}
              {settings.phone && (
                <li className="flex items-center gap-3"><Phone size={14} strokeWidth={1.5} /> <a href={`tel:${settings.phone}`} className="hover:text-[#C57457]">{settings.phone}</a></li>
              )}
              <li className="flex items-center gap-3"><Instagram size={14} strokeWidth={1.5} /> <a href={settings.instagram || "https://www.instagram.com/thehiraya_"} target="_blank" rel="noreferrer" className="hover:text-[#C57457]">@thehiraya_</a></li>
            </ul>
            <div className="mt-8 text-[11px] text-[#8A837A]">© {new Date().getFullYear()} Hiraya. All rights reserved.</div>
            <div className="mt-2 text-[11px] flex gap-4">
              <Link to="/privacy" className="text-[#8A837A] hover:text-[#C57457]">Privacy</Link>
              <Link to="/terms" className="text-[#8A837A] hover:text-[#C57457]">Terms</Link>
              <Link to="/cookies" className="text-[#8A837A] hover:text-[#C57457]">Cookies</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
